(function () {
  'use strict';

  var fmt = function (cents) {
    return (cents / 100).toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €';
  };

  function init(root) {
    if (root.dataset.mspReady) return;
    root.dataset.mspReady = '1';
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var variants = [];
    try { variants = JSON.parse(root.querySelector('[data-variants]').textContent); } catch (e) {}
    if (!variants.length) return;

    var params = new URLSearchParams(window.location.search);
    var cur = variants.find(function (v) { return String(v.id) === params.get('variant'); }) ||
      variants.find(function (v) { return v.available; }) || variants[0];
    var selected = cur.options.slice();
    var freeFrom = parseInt(root.dataset.freeFrom, 10) || 0;
    var cartTotal = null;

    /* ---------- Gallery ---------- */
    var main = root.querySelector('[data-gal-main]');
    var mainImg = root.querySelector('[data-gal-img]');
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-media-id]'));
    function showThumb(btn) {
      if (!btn || !mainImg) return;
      thumbs.forEach(function (t) { t.classList.toggle('is-active', t === btn); });
      if (mainImg.getAttribute('src') !== btn.dataset.src) {
        mainImg.classList.remove('is-in');
        mainImg.src = btn.dataset.src;
        void mainImg.offsetWidth;
        mainImg.classList.add('is-in');
      }
      btn.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: reduce ? 'auto' : 'smooth' });
    }
    function step(d) {
      var i = thumbs.findIndex(function (t) { return t.classList.contains('is-active'); });
      showThumb(thumbs[(i + d + thumbs.length) % thumbs.length]);
    }
    thumbs.forEach(function (t) { t.addEventListener('click', function () { showThumb(t); }); });
    root.querySelectorAll('[data-gal-step]').forEach(function (b) {
      b.addEventListener('click', function () { step(parseInt(b.dataset.galStep, 10)); });
    });
    if (main && thumbs.length > 1) {
      var x0 = null;
      main.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
      main.addEventListener('touchend', function (e) {
        if (x0 === null) return;
        var dx = e.changedTouches[0].clientX - x0;
        if (Math.abs(dx) > 40) step(dx < 0 ? 1 : -1);
        x0 = null;
      });
    }

    /* ---------- Variant state ---------- */
    function match() {
      return variants.find(function (v) {
        return v.options.every(function (o, i) { return o === selected[i]; });
      });
    }

    function render(fromUser) {
      var v = match();
      root.querySelectorAll('[data-opt]').forEach(function (group) {
        var i = parseInt(group.dataset.opt, 10);
        group.querySelectorAll('[data-value]').forEach(function (b) {
          b.setAttribute('aria-checked', b.dataset.value === selected[i] ? 'true' : 'false');
          if (!b.classList.contains('msp-size')) {
            var probe = selected.slice(); probe[i] = b.dataset.value;
            var pv = variants.find(function (x) { return x.options.every(function (o, k) { return o === probe[k]; }); });
            b.classList.toggle('is-soldout', !pv || !pv.available);
          }
        });
        var name = root.querySelector('[data-opt-name="' + i + '"]');
        if (name) name.textContent = selected[i];
      });

      var ok = !!(v && v.available);
      var price = v ? v.price : 0;
      var sale = v && v.compare > v.price;
      root.querySelectorAll('[data-now]').forEach(function (el) { el.textContent = v ? fmt(price) : '–'; });
      root.querySelectorAll('[data-was]').forEach(function (el) { el.textContent = sale ? fmt(v.compare) : ''; });
      root.querySelectorAll('[data-was-wrap]').forEach(function (el) { el.hidden = !sale; });
      root.querySelectorAll('[data-off], [data-badge]').forEach(function (el) {
        el.hidden = !sale;
        if (sale) el.textContent = '−' + Math.round((v.compare - v.price) / v.compare * 100) + ' %';
      });
      root.querySelectorAll('[data-unit]').forEach(function (el) {
        el.textContent = v && v.ml > 0 ? fmt(Math.round(v.price * 100 / v.ml)) + ' / 100 ml' : '';
      });
      root.querySelectorAll('[data-sticky-variant]').forEach(function (el) { el.textContent = v ? v.title : ''; });

      var stock = root.querySelector('[data-stock]');
      if (stock) {
        stock.className = 'msp-stock';
        if (!v) { stock.textContent = 'Diese Kombination gibt es nicht.'; stock.classList.add('is-out'); }
        else if (!v.available) { stock.textContent = 'Ausverkauft'; stock.classList.add('is-out'); }
        else if (v.inv !== null && v.inv > 0 && v.inv <= 5) {
          stock.innerHTML = '<i></i>' + (root.dataset.lowText || '').replace('[n]', v.inv);
          stock.classList.add('is-low');
        } else { stock.innerHTML = '<i></i>' + (root.dataset.stockText || ''); }
      }

      root.querySelectorAll('[data-submit]').forEach(function (b) {
        b.disabled = !ok;
        if (b.dataset.short !== undefined) b.textContent = ok ? 'In den Warenkorb' : 'Ausverkauft';
        else b.textContent = ok ? 'In den Warenkorb · ' + fmt(price * qty()) : 'Ausverkauft';
      });
      renderShip();

      if (v && fromUser) {
        cur = v;
        if (v.media) showThumb(thumbs.find(function (t) { return t.dataset.mediaId === String(v.media); }));
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      }
    }

    root.querySelectorAll('[data-opt]').forEach(function (group) {
      var i = parseInt(group.dataset.opt, 10);
      group.querySelectorAll('[data-value]').forEach(function (b) {
        b.addEventListener('click', function () { selected[i] = b.dataset.value; render(true); });
      });
    });

    /* ---------- Quantity ---------- */
    var qtyInput = root.querySelector('[data-qty]');
    function qty() { return Math.max(1, parseInt(qtyInput && qtyInput.value, 10) || 1); }
    root.querySelectorAll('[data-qty-step]').forEach(function (b) {
      b.addEventListener('click', function () {
        qtyInput.value = Math.max(1, qty() + parseInt(b.dataset.qtyStep, 10));
        render(false);
      });
    });
    if (qtyInput) qtyInput.addEventListener('change', function () { qtyInput.value = qty(); render(false); });

    /* ---------- Free shipping hint ---------- */
    function renderShip() {
      var el = root.querySelector('[data-ship]');
      if (!el || !freeFrom) return;
      var v = match();
      if (!v || !v.available) { el.innerHTML = ''; return; }
      var total = (cartTotal || 0) + v.price * qty();
      if (total >= freeFrom) {
        el.innerHTML = '<span class="msp-ship__ok">✓ Mit diesem Artikel versenden wir kostenlos.</span>';
      } else {
        var pct = Math.min(100, Math.round(total / freeFrom * 100));
        el.innerHTML = 'Noch <b>' + fmt(freeFrom - total) + '</b> bis zum kostenlosen Versand<span class="msp-ship__bar"><i style="width:' + pct + '%"></i></span>';
      }
    }
    function loadCart() {
      return fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (c) { cartTotal = c.total_price || 0; renderShip(); return c; })
        .catch(function () {});
    }

    /* ---------- Add to cart ---------- */
    var msg = root.querySelector('[data-msg]');
    root.querySelectorAll('[data-submit]').forEach(function (b) {
      b.addEventListener('click', function () {
        var v = match();
        if (!v || !v.available) return;
        var all = root.querySelectorAll('[data-submit]');
        all.forEach(function (x) { x.disabled = true; x.classList.add('is-busy'); });
        if (msg) { msg.textContent = ''; msg.classList.remove('is-error'); }
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: v.id, quantity: qty() }] })
        })
          .then(function (r) { return r.json().then(function (d) { if (!r.ok) throw new Error(d.description || d.message || 'Fehler'); return d; }); })
          .then(function () {
            all.forEach(function (x) { x.classList.remove('is-busy'); });
            if (typeof window.emit === 'function') {
              loadCart().then(function (c) {
                if (c) window.emit('cart:updated', { cart: c });
                window.emit('quick-cart:updated');
                window.emit('quick-cart:open');
                render(false);
              });
            } else {
              window.location.href = '/cart';
            }
          })
          .catch(function (err) {
            all.forEach(function (x) { x.classList.remove('is-busy'); });
            if (msg) { msg.textContent = err.message; msg.classList.add('is-error'); }
            render(false);
          });
      });
    });

    /* ---------- Sticky add-to-cart ---------- */
    var sticky = root.querySelector('[data-sticky]');
    var cta = root.querySelector('.msp-cta');
    if (sticky && cta && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var e = entries[0];
        var show = !e.isIntersecting && e.boundingClientRect.top < 0;
        sticky.classList.toggle('is-visible', show);
        sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
        sticky.querySelectorAll('button').forEach(function (b) { b.tabIndex = show ? 0 : -1; });
      }).observe(cta);
    }

    render(false);
    loadCart();
  }

  function boot() { document.querySelectorAll('.msp').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
